export const GithubIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="black"
        d="M12 0.297C5.373 0.297 0 5.67 0 12.297C0 17.616 3.438 22.016 8.207 23.542C8.805 23.648 9.025 23.297 9.025 22.994C9.025 22.723 9.015 22.066 9.01 21.238C5.672 21.915 4.968 19.54 4.968 19.54C4.422 18.14 3.633 17.765 3.633 17.765C2.546 17.032 3.717 17.048 3.717 17.048C4.922 17.132 5.555 18.29 5.555 18.29C6.625 20.101 8.388 19.582 9.048 19.283C9.153 18.503 9.465 17.97 9.81 17.664C7.145 17.355 4.343 16.292 4.343 11.635C4.343 10.301 4.807 9.222 5.59 8.375C5.462 8.066 5.043 6.809 5.707 5.11C5.707 5.11 6.722 4.782 8.995 6.374C9.96 6.098 10.98 5.961 12 5.956C13.02 5.961 14.04 6.098 15.005 6.374C17.277 4.782 18.29 5.11 18.29 5.11C18.957 6.809 18.537 8.066 18.41 8.375C19.195 9.222 19.655 10.301 19.655 11.635C19.655 16.306 16.847 17.349 14.172 17.652C14.615 18.035 15.013 18.799 15.013 20.008C15.013 21.723 15 22.988 15 22.994C15 23.297 15.217 23.651 15.822 23.541C20.584 22.012 24 17.614 24 12.297C24 5.67 18.627 0.297 12 0.297Z"
      />
    </svg>
  );
};
